module.exports = __webpack_public_path__ + "static/media/0011.cd4fbde9.png";